import React from 'react';
import { convertDate } from '../../helpers/dateFormat';
import InfoLabel, { DATE_HELP } from '../../../components/data/info-label.jsx';

// Empty cells show "-" instead of nothing.
const EMPTY = '-'
const orEmpty = (value) => (value === null || value === undefined || value === '' ? EMPTY : value)
const dateOrEmpty = (value) => (value ? convertDate(String(value)) : EMPTY)

// Status of an item where this vendor is only the supplier (a separate finisher
// does the rest): it lives in vendor_delivery_status, not vendor_status. Names
// match SuppliersSteps (finisher-step.js) and the kanban columns. Kept here,
// not imported, because finisher-step.js imports the production routes.
const SupplierStatus = {
    1: 'Order Confirmation',
    2: 'In Production',
    3: 'Expected Delivery date',
    4: 'In Transit',
    5: 'Delivered',
}
const SUPPLIER_FLOW = 2 // supplier_flow set by the vendor items API
// vendor_status 12 (CANCELED) has no production step, so no name in ProductionStatus.
const VENDOR_STATUS_CANCELED = 12
// import styles from '../../../styles/page.scss'
import { ProductionStatus } from '../production-steps'


export const ProductionColumn = [
    {
        title: 'Project Id',
        dataIndex: 'global_project_id',
        render: orEmpty,
    },
    {
        title: <InfoLabel label="Received Date" info={DATE_HELP.productionReceived} />,
        dataIndex: 'createdAt',
        render: dateOrEmpty
    },
    {
        title: <InfoLabel label="Deadline Delivery Date" info={DATE_HELP.deadlineDelivery} />,
        dataIndex: 'client_expected_delivery_date',
        render: dateOrEmpty
    },
    {
        title: 'Status',
        dataIndex: 'vendor_status',
        render: (status, record) => orEmpty(record?.supplier_flow === SUPPLIER_FLOW
            ? SupplierStatus[record.vendor_delivery_status]
            : ProductionStatus[status] ?? (status === VENDOR_STATUS_CANCELED ? 'Cancelled' : undefined)),

    }

]

export const ProductionKanabanColumn = [
    {
        key: 1,
        title: 'New Order'
    },
    {
        key: 2,
        title: 'Template Requested'
    },
    {
        key: 3,
        title: 'Template Sent'
    },
    {
        key: 4,
        title: 'ArtWork Received'
    },
    {
        key: 5,
        title: 'Final Proof Sent'
    },
    {
        key: 6,
        title: 'Approved by Leoprinting'
    },
    {
        key: 7,
        title: 'On Hold'
    },
    {
        key: 8,
        supplierStatus: 2,
        title: 'In Production'
    },
    {
        key: 9,
        supplierStatus: 3,
        title: 'Expected Dispatch date'
    },
    {
        key: 10,
        supplierStatus: 4,
        title: 'In Transit'
    },
    {
        key: 11,
        supplierStatus: 5,
        title: 'Delivered'
    },

]